import { Component, OnInit, ViewChild } from '@angular/core';
import { GiveawayStock } from './giveaway-stock.model';
import { DisplayModes } from '../../models/enums';
import { Router } from '@angular/router';
import { AppTranslationService } from '../../services/app-translation.service';
import { AccountService } from '../../services/account.service';
import { AppConfigService } from '../../app.config';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { UsersApiService } from '../../services/users-api.service';
import { Permission } from '../../models/permission.model';
import { ModalDirective } from "ngx-bootstrap";
import { GiveawayStockService } from './giveaway-stock.service';

@Component({
  selector: 'crm-giveaway-stock',
  templateUrl: './giveaway-stock.component.html',
  styleUrls: ['./giveaway-stock.component.css']
})
export class GiveawayStockComponent implements OnInit {
  stocks: GiveawayStock[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  pageSize: number;
  userId;
  public logo = "";

  @ViewChild('deleteModal')
  deleteModal: ModalDirective;
  selectedtId;
  addNew: boolean = false;

  constructor(private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService,
    private readonly usersService: UsersApiService,
    private readonly appConfig: AppConfigService,
    private readonly giveawayStockService: GiveawayStockService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.getStocks();
  }

  getStocks() {
    this.displayMode = DisplayModes.Loading;
    this.giveawayStockService.getAll().subscribe(responce => {
      this.stocks = responce as GiveawayStock[];
      this.displayMode = DisplayModes.Success;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get giveaway stocks');
        console.log(err);
      })
        }


  add() {
    this.addNew = true;
  }

  edit(id) {
    this.selectedtId = id;
    this.addNew = true;
  }


  confirmDelete(request) {
    this.selectedtId = request;
    this.deleteModal.show();
  }

  deleteRequest() {
    this.hideDeleteModal();
    this.displayMode = DisplayModes.Loading;
    this.giveawayStockService.delete(this.selectedtId.id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("clm.deletedSuccessfully"), MessageSeverity.Success);

      let index = this.stocks.indexOf(this.selectedtId);
      this.stocks.splice(index, 1);
    }, error => {
      this.displayMode = DisplayModes.Error;
      this.alertService.showStickyMessage("Save Error", "The below errors occured while delete request:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });
  }

  get canAddGiveawayStock() {
    return this.accountService.userHasPermission(Permission.createGiveawayStocks);
  }

  get canDeleteGiveawayStock() {
    return this.accountService.userHasPermission(Permission.deleteGiveawayStocks);
  }

  get canEditGiveawayStock() {
    return this.accountService.userHasPermission(Permission.editGiveawayStocks);
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

  closeAdding(event) {
    this.selectedtId = undefined;
    this.addNew = false;

    if (event) {
      this.getStocks();
    }
  }

}
